import { spiritIslandChapters } from './content';
export const spiritIslandGlossary = spiritIslandChapters.find((chapter) => chapter.title.toLocaleUpperCase('pl').includes('GLOSSARY'));
